import React from "react";
import { Navigate, Route } from "react-router-dom";
import {
  DashboardOverviewPage,
  DashboardContentPage,
  DashboardProductsPage,
  DashboardProjectsPage,
  DashboardSolutionsPage,
  DashboardSectorsPage,
  DashboardCareersPage,
  DashboardCoursesPage,
  DashboardTrainingsPage,
  DashboardDownloadsPage,
  DashboardCallsRequestedPage,
  DashboardContactUsPage,
  DashboardSubscribersPage,
  DashboardUsersPage,
  DashboardBlogPage,
} from "../pages/Dashboard/pages/DashboardPages";
import { DEFAULT_CONTENT_PAGE, DEFAULT_PRODUCT_TYPE } from "../pages/Dashboard/dashboardNavConfig";

/**
 * Nested routes under `/dashboard` — must be a Fragment of <Route> nodes, not a wrapper component.
 * Use as: <Route path="/dashboard" ...>{dashboardRouteElements}</Route>
 */
export const dashboardRouteElements = (
  <>
    <Route index element={<Navigate to={`content/${DEFAULT_CONTENT_PAGE}`} replace />} />
    <Route path="overview" element={<DashboardOverviewPage />} />
    <Route path="content" element={<Navigate to={DEFAULT_CONTENT_PAGE} replace />} />
    <Route path="content/:pageKey" element={<DashboardContentPage />} />
    <Route path="products" element={<Navigate to={DEFAULT_PRODUCT_TYPE} replace />} />
    <Route path="products/:productType" element={<DashboardProductsPage />} />
    <Route path="projects" element={<DashboardProjectsPage />} />
    <Route path="solutions" element={<DashboardSolutionsPage />} />
    <Route path="sectors" element={<DashboardSectorsPage />} />
    <Route path="careers" element={<DashboardCareersPage />} />
    <Route path="courses" element={<DashboardCoursesPage />} />
    <Route path="trainings" element={<DashboardTrainingsPage />} />
    <Route path="downloads" element={<DashboardDownloadsPage />} />
    <Route path="calls-requested" element={<DashboardCallsRequestedPage />} />
    <Route path="contact-us" element={<DashboardContactUsPage />} />
    <Route path="subscribers" element={<DashboardSubscribersPage />} />
    <Route path="users" element={<DashboardUsersPage />} />
    <Route path="blog" element={<DashboardBlogPage />} />
    <Route path="*" element={<Navigate to={`content/${DEFAULT_CONTENT_PAGE}`} replace />} />
  </>
);
